import { FC } from 'react';
import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import P2 from '@base/P2/P2';
import Image from '@base/Image';
import { pluralize } from '@utils/textHelper';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings, mediaQuery } from '@styles/index';

const Flex = styled.div`
  display: flex;
`;

const OfferCont = styled.div`
  background-color: var(--color-base-1);
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_3B};
  box-shadow: ${boxShadowGenerator()};
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B};
    margin-bottom: ${Spacings.SPACING_2B};
  }
`;

const OfferIconWrap = styled.div`
  opacity: 0.6;
  margin-right: ${Spacings.SPACING_4B};
  flex-shrink: 0;
  ${mediaQuery.uptoMobile} {
    margin-right: ${Spacings.SPACING_2B};
  }
`;

const OfferLabel = styled(P1)`
  margin-bottom: ${Spacings.SPACING_2};
`;

const getDurationText = (duration) => {
  if (duration < 30) return pluralize(duration, 'day');
  return pluralize(Math.floor(duration / 30), 'month');
};

interface ISubscriptionInfoOfferProps {
  extraDuration?: number;
}

const SubscriptionInfoOffer: FC<ISubscriptionInfoOfferProps> = ({
  extraDuration = 0
}) => {
  return (
    <>
      {extraDuration ? (
        <OfferCont>
          <Flex>
            <OfferIconWrap>
              <Image
                src="checkout/offer.svg"
                alt="offer"
                width={24}
                height={24}
              />
            </OfferIconWrap>
            <div>
              <OfferLabel>Offer applied</OfferLabel>
              <P2 color="var(--color-text-secondary)">
                {`${getDurationText(
                  extraDuration
                )} added to your subscription for free`}
              </P2>
            </div>
          </Flex>
        </OfferCont>
      ) : null}
    </>
  );
};

export default SubscriptionInfoOffer;
